import { createState, State } from '@hookstate/core';
import { createContext } from 'react';

export const disabledPreviousValueContext = createContext<State<Record<string, string>>>(createState<Record<string, string>>({}));
